<template>
<v-touch tag="div"   @swipeleft="handleScroll" @swiperight="handleScroll">
  <el-scrollbar  ref="scrollContainer" wrap-class="scrollbar-wrapper-x" :vertical="false" class="scroll-container height-p100" @wheel.native.prevent="handleScroll">
    <slot />
  </el-scrollbar>
</v-touch>
</template>

<script>
const tagAndTagSpacing = 4 // tagAndTagSpacing

export default {
    name: `ScrollPane`,
    data() {
        return {
            left: 0
        }
    },
    computed: {
        scrollWrapper() {
            return this.$refs.scrollContainer.$refs.wrap
        }
    },
    methods: {
        handleScroll(e) {
            let eventDelta = 0
            if (e.type == `wheel`) {
                eventDelta = e.wheelDelta || e.deltaY * 10
            } else if (e.type == `swipeleft`) {
                eventDelta = e.deltaX * 5
            } else if (e.type == `swiperight`) {
                eventDelta = e.deltaX * 5
            }
            const $scrollWrapper = this.scrollWrapper
            $scrollWrapper.scrollLeft = $scrollWrapper.scrollLeft - eventDelta
        },
        moveToTarget(currentTag) {
            const $container = this.$refs.scrollContainer.$el
            const $containerWidth = $container.offsetWidth
            const $scrollWrapper = this.scrollWrapper
            const tagList = this.$parent.$refs.tag

            let firstTag = null
            let lastTag = null

            // find first tag and last tag
            if (tagList.length > 0) {
                firstTag = tagList[0]
                lastTag = tagList[tagList.length - 1]
            }

            if (firstTag === currentTag) {
                $scrollWrapper.scrollLeft = 0
            } else if (lastTag === currentTag) {
                $scrollWrapper.scrollLeft = $scrollWrapper.scrollWidth - $containerWidth
            } else {
                // find preTag and nextTag
                const currentIndex = tagList.findIndex(item => item === currentTag)
                const prevTag = tagList[currentIndex - 1]
                const nextTag = tagList[currentIndex + 1]

                // the tag's offsetLeft after of nextTag
                const afterNextTagOffsetLeft = nextTag.$el.offsetLeft + nextTag.$el.offsetWidth + tagAndTagSpacing

                // the tag's offsetLeft before of prevTag
                const beforePrevTagOffsetLeft = prevTag.$el.offsetLeft - tagAndTagSpacing

                if (afterNextTagOffsetLeft > $scrollWrapper.scrollLeft + $containerWidth) {
                    $scrollWrapper.scrollLeft = afterNextTagOffsetLeft - $containerWidth
                } else if (beforePrevTagOffsetLeft < $scrollWrapper.scrollLeft) {
                    $scrollWrapper.scrollLeft = beforePrevTagOffsetLeft
                }
            }
        }
    }
}
</script>
<style  lang="less">
  .scroll-container {
    .el-scrollbar__bar {
      // display: none;
      opacity: 0.5;
    }
    .is-vertical{
      display: none;
    }
  }
</style>
<style scoped lang="less">
  .scroll-container {
    white-space: nowrap;
    position: relative;
    overflow: hidden;
    width: 100%;
    text-align: left;
    .is-vertical{
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/common/ScrollPane.vue